import { padNumber, isNumber, toInteger } from "./function";
import {
  NgbDateNativeAdapter,
  NgbDateParserFormatter,
  NgbDateStruct
} from "@ng-bootstrap/ng-bootstrap";
export class DateAdapter extends NgbDateNativeAdapter {
  fromModel(date: any) {
    if (typeof date === "string") {
      date = new Date(date);
    }

    return date && date.getFullYear
      ? {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        }
      : null;
  }
}

export class EsDateFormat extends NgbDateParserFormatter {
  parse(value: string) {
    if (value) {
      const dateParts = value.trim().split("/");

      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return { day: toInteger(dateParts[0]), month: null, year: null };
      } else if (
        dateParts.length === 2 &&
        isNumber(dateParts[0]) &&
        isNumber(dateParts[1])
      ) {
        return {
          day: toInteger(dateParts[0]),
          month: toInteger(dateParts[1]),
          year: null
        };
      } else if (
        dateParts.length === 3 &&
        isNumber(dateParts[0]) &&
        isNumber(dateParts[1]) &&
        isNumber(dateParts[2])
      ) {
        return {
          day: toInteger(dateParts[0]),
          month: toInteger(dateParts[1]),
          year: toInteger(dateParts[2])
        };
      }
    }

    return null;
  }

  format(date: NgbDateStruct) {
    return date
      ? (isNumber(date.day) ? padNumber(date.day) : "") +
          "/" +
          (isNumber(date.month) ? padNumber(date.month) : "") +
          "/" +
          (isNumber(date.year) ? date.year : "")
      : "";
  }
}
